<!--
트래킹검수 > 헤더
------------------------------------
-->
<template>
    <div>
        <!-- 안건 72 (2026-05-12): 옛 menuHtml 인라인 펼침 UX 폐기 → 좌측 ref020-sidebar 토글 -->
        <div class="search-bar uk-flex uk-flex-left uk-flex-wrap">
            <!-- 메뉴 토글 — window event 로 ref020-sidebar 슬라이드인/아웃 -->
            <a class="menu" @click="toggleSidebar" title="사이드바 토글">
                <i class="material-icons">menu</i>
            </a>

            <!-- 스캔번호 -->
            <div class="scan-no" @click="$parent.showScan" title="Retry scan">
                <i class="material-icons">
                    aspect_ratio
                </i>
                SCAN
                <span class="none uk-margin-small-left" v-show="! scanNo">NONE</span>
                <span class="highlight uk-margin-small-left" v-show="scanNo">
                {{ scanNo }}
            </span>
            </div>

            <!-- 긴급입고 -->
            <div class="urgent-ship-in" @click="$parent.showUrgentShipIn" v-show="urgentShipIn">
                긴급입고
            </div>


            <!-- 조회된 트래킹 수 -->
            <div class="" v-show="! foundCount" title="Show found tracking list">
                <i class="material-icons">
                    search
                </i>
                <span>HAS NOT FOUND</span>
            </div>
            <div class="found-count" title="조회된 트래킹 내역" v-show="foundCount" @click="$parent.showTrackings">
                <i class="material-icons">
                    search
                </i>
                FOUND
                <span class="highlight">{{ foundCount }}</span>
            </div>

            <div class="uk-width-expand">
            </div>

            <!-- 현재 선택된 트래킹번호 -->
            <div class="select-no" title="검수대상으로 선택된 트래킹번호" @click="$parent.checkInfoRefresh">
            <span class="total-amount-header" v-show="selectTracking" title="트래킹BOX 내 상품 전체수량">
                전체수량 :
            </span>
                <span class="total-amount uk-margin-small-right" v-show="selectTracking">
                {{ selectedTotalProdAmount }}
            </span>

                <i class="material-icons" v-show="selectTracking">
                    local_shipping
                </i>
                <span class="highlight uk-margin-small-right" v-show="selectTracking">
                {{ selectedTrackingNo }}
            </span>
                <i class="material-icons" v-show="selectTracking">
                    mail
                </i>
                <span class="highlight uk-margin-small-right" v-show="selectTracking">
                {{ selectedUserMailbox }}
            </span>

                <!--
                <i class="material-icons" v-show="selectTracking">
                    home
                </i>
                <span class="highlight uk-margin-small-right" v-show="selectTracking">
                    {{ selectedUserNick }}
                </span>
                -->
            </div>

        </div>
    </div>

</template>

<script>
    // REF-020 hot-fix #20 안건 72 (2026-05-12): menu-able mixin 폐기. ref020-sidebar 토글로 대체.
    export default {
        props: {
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 스캔번호
             */
            scanNo: {
                type: String,
                default: null,
            },

            /**
             * 스캔번호에 대한 긴급입고정보
             */
            urgentShipIn: {
                type: Object,
                default: null,
            },

            /**
             * 조회된 트래킹 건수
             */
            foundCount: {
                type: Number,
                default: 0,
            },

            /**
             * 현재 선택된 트래킹정보
             */
            selectTracking: {
                type: Object,
                default: null,
            },



        },
        data: function () {
            return {
            };
        },
        computed: {

            // 현재 선택된 트래킹번호
            selectedTrackingNo: function () {
                if (this.selectTracking) {
                    return this.selectTracking.tracking_no;
                }
                return null;
            },

            // 현재 선택된 사서함
            selectedUserMailbox: function () {
                if (this.selectTracking) {
                    return this.selectTracking.user_mailbox;
                }
                return null;
            },

            // 현재 선택된 사용자
            selectedUserNick: function () {
                if (this.selectTracking) {
                    return this.selectTracking.user_nick;
                }
                return null;
            },

            // 현재 선택된 총 수량
            selectedTotalProdAmount: function () {
                if (this.selectTracking) {
                    return this.selectTracking.total_prod_amount;
                }
                return null;
            },
        },
        methods: {
            // 안건 72 (2026-05-12): 메뉴버튼 클릭 시 ref020-sidebar 토글.
            toggleSidebar() {
                window.dispatchEvent(new CustomEvent('ref020-sidebar-toggle'));
            },
        },
    }
</script>

<style lang="scss" scoped>
    .search-bar{
        border: 0;
        //padding: 10px;
        background-color: #1F2B3D !important;
        //border-bottom: 3px solid #666 !important;


        font-size: 1rem;
        color: #8fa2c2;
        //color: #fff;

        // 자식 1뎁스메뉴 패딩처리
        & > div {
            padding: 0.5rem;
        }

        // 메뉴 펼치기
        a.menu {
            display: flex;
            align-items: center;
            text-decoration: none;

            padding: 0 0.5rem;
            color: #fff;

            .material-icons {
                font-size: 2rem;
            }


            &.open {
                color: #1F2B3D;
                background-color: #fff;
            }


        }

        .total-amount-header {
            //font-weight: bold;
            margin-right: 1rem;
            color: #fff;
        }

        .total-amount {
            font-size: 1.25rem;
            color: #FFFD7C;
        }

        .material-icons {
            vertical-align: middle;
            font-size: 1.5rem;
        }

        .none {
            font-size: 1rem;
            color: #999;
        }

        .highlight {
            font-size: 1rem;
            color: #fff;
        }

        .found-count {
            cursor: pointer;
            font-size: 1rem;

            .highlight {
                font-size: 1.25rem;
            }
        }

        .scan-no {
            cursor: pointer;
        }

        .urgent-ship-in {
            cursor: pointer;
            background-color: #ee395b;
            color: #fff;
            padding: 5px;
        }

        .select-no {
            cursor: pointer;
        }

    }
</style>